import { Container, Row } from "reactstrap";
import { BasicInitTitle, DataTitle } from "../../../../../constants";
import ZeroConfigurationTable from "./ZeroConfigurationTable";
import StateSavingTable from "./StateSavingTable";
import ScrollVerticalDynamicHeight from "./ScrollVerticalDynamicHeight";
import Breadcrumbs from "../../../../../coreComponents/breadcrumbs";

const BasicInitContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={BasicInitTitle} parent={DataTitle} />
      <Container fluid>
        <Row>
          <ZeroConfigurationTable />
          <StateSavingTable />
          <ScrollVerticalDynamicHeight />
        </Row>
      </Container>
    </>
  );
};

export default BasicInitContainer;
